/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { createPromiseRequest } from './util/createPromiseRequest';
import { hasAccessToken } from '../../scanline/utils/token';

export const fetchMessages = (uuids) => {
	const url = '/ddb/list';

	if (hasAccessToken()) {
		const _fetchMessages = createPromiseRequest({
			url,
			method: 'POST',
			data: { uuids } // if uuids are empty or undefined, it will return all messages. ['4113b5d4-f621-4f1a-80da-dc834fa8e5eb', 'd5ca22f7-1f38-4418-a52d-1b240bb8a6ac']
		});
		return _fetchMessages();
	}
};

// creates the initial message to later be sent, stored in ddb.
export const queueMessage = (message) => {
	const url = '/ddb/queue';

	if (hasAccessToken()) {
		const _queueMessage = createPromiseRequest({
			url,
			method: 'POST',
			data: message?.toJSON ? message?.toJSON() : message,
		});
		return _queueMessage();
	}
};

// sends a list of message to backend to be merged and prepped for email delivery.
export const sendMessages = (messages = []) => {
	const url = '/ddb-to-sqs/send';

	if (hasAccessToken() && messages?.length) {
		const _queueMessage = createPromiseRequest({
			url,
			method: 'POST',
			data: { uuids: messages.map(m => m.uuid)},
		});
		return _queueMessage();
	}
};

export const deleteMessage = (message) => {
	const url = '/ddb/delete';

	if (hasAccessToken()) {
		const _deleteMessage = createPromiseRequest({
			url,
			method: 'POST',
			data: { uuid: message?.toJSON ? message?.toJSON().uuid : message?.uuid }
		});
		return _deleteMessage();
	}
};